import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface DeleteTransientStayDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  bookingNumber: string
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteTransientStayDialog({
  open,
  onOpenChange,
  bookingNumber,
  onConfirm,
  isDeleting,
}: DeleteTransientStayDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Transient Stay</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete transient stay{' '}
            <span className="font-mono font-medium">{bookingNumber}</span>?
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isDeleting}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isDeleting ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
